import styled from 'styled-components';

export const CollapseItemWrapper = styled.div`
.item-container{
  margin-bottom: 8px;
}

.item-container-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.9rem 0.9rem;
  text-align: left;
  border: 1px solid #e2e2e2;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.RadioButton p {
  font-weight: bold;
}

hgroup{
  width: 80%;
}

.direccion{
  padding-left: 33px;
  color: rgba(56,56,56,0.5);
  margin-top: 8px;
}

.AccordionItem--collapsed-indicator{
  padding-bottom: 20px;
}

.AccordionItem--collapsed-indicator img{
  height: 8.23px;
  width: 13.97px;
}

.AccordionItem--content{
  border-left: 1px solid #E2E2E2;
  border-right: 1px solid #E2E2E2;
  border-bottom: 1px solid #E2E2E2;
  border-radius: 0px 0px 5px 5px;

  display: flex;
  padding: 10px 16px 16px 20px;
}

.AccordionItem--content span{
  color: #007DB7;
}

.AccordionItem--content p{
  color: rgba(56,56,56,0.5);
}

.AccordionItem--content p:first-of-type{
  margin-bottom: 10px;
}

.Accordion-item-open{
  background-color: rgba(0,161,223,0.1);
  border-radius: 5px 5px 0 0;
}

.container-horario-icon{
  margin-right: 8px;
}

`;

export default CollapseItemWrapper;